
import AV from "leancloud-storage";
import { User } from "@/models";
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
name: "LogInBySmsCode",
created() {},
props: {},
data() {
return {
phone: null,
code: null,
};
},
metaInfo() {
return {
title: "登录",
};
},
methods: {
async sendSmsCode() {
let phone = (this.phone || "").trim();

if (phone == "") {
this.$vux.toast.text("手机号不能为空", "middle");
return;
}

let exist = await User.checkPhoneExist(phone);
console.log(exist);
if (!exist) {
this.$vux.toast.text("该手机号尚未注册", "middle");
return;
}

try {
await AV.Cloud.run("markMobilePhoneAsVerified", {
phone: this.phone,
});
await User.requestLoginSmsCode(phone);
} catch (err) {
this.$vux.toast.text(`验证码发送失败：${err.message}`, "middle");
return;
}

this.$vux.toast.text("验证码发送成功，请查收短信", "middle");
this.$vux.toast.show({
text: "验证码发送成功，请查收短信",
position: "middle",
});
},

async logIn() {
if (!this.phone) {
this.$vux.toast.text("手机号不能为空", "middle");
return;
}

if (!this.code) {
this.$vux.toast.text("验证码不能为空", "middle");
return;
}

try {
let user = await User.logInWithMobilePhoneSmsCode(this.phone, this.code);

this.$store.commit("logIn", user.toJSON());
this.$router.push({ path: this.from || "/" });
} catch (err) {
this.$vux.toast.text("验证码过期或错误", "middle");
}
},
},

computed: {},
components: {
XInput,
Group,
XButton,
},
};



// WEBPACK FOOTER //
// ./src/pages/account/LogInBySmsCode.vue